import { Skeleton, SkeletonGroup } from "@/components/ui/Skeleton";
import styles from "./GuestInviteSkeleton.module.scss";

/** Envelope-shaped placeholder while the invitation loads. */
export function GuestInviteSkeleton() {
  return (
    <SkeletonGroup label="Opening your invitation" className={styles.screen}>
      <span className={styles.envelope} aria-hidden="true">
        <Skeleton className={styles.body} width="100%" height="100%" radius="0.3rem" />
        <span className={styles.flap} />
        <Skeleton className={styles.seal} width="3rem" height="3rem" radius="50%" />
      </span>
      <Skeleton width="11rem" height="0.8rem" />
    </SkeletonGroup>
  );
}
